import BaseModelFactory from './base.factory'
import LedgerTransactionService from './../services/LedgerTransaction.service'
import LedgerTransaction from './../models/ledger-transaction.model'

class LedgerTransactionFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: LedgerTransactionService, Model: LedgerTransaction }
    )
  static findById = async id =>
    await this._findBy({ id }, { Service: LedgerTransactionService, Model: LedgerTransaction })
  static create = payload =>
    this._create(payload, {
      Service: LedgerTransactionService,
      Model: LedgerTransaction,
    })
}

export default LedgerTransactionFactory
